<template>
	<v-layout justify-center>
		<v-flex xs12 sm12 md12>
			<v-container :key="this.$route.name">
				<v-row no-gutters>
					<v-col
						v-for="event in eventItems"
						:key="event.title"
						class="align-items-center pa-3"
					>
						<v-btn
							text
							block
							@click="setID(event.id)"
							:class="{ active: event.id === eventID }"
						>
							<span class="text-uppercase" text>{{ event.title }}</span>
						</v-btn>
					</v-col>
				</v-row>
				<EventClassContainer :eventID="eventID" />
			</v-container>
		</v-flex>
	</v-layout>
</template>

<script>
import EventClassContainer from "./EventClassContainer.vue";
import { Events } from "../../Models/Events";
import _ from "lodash";

export default {
	components: {
		EventClassContainer,
	},
	data() {
		const typedEvents = _.filter(Events, (evt) => {
			return evt.route === this.$route.name;
		});
		return {
			eventID: typedEvents[0].id,
			eventItems: typedEvents,
		};
	},
	watch: {
		$route(to, from) {
			if (to.name !== from.name) {
				const typedEvents = _.filter(Events, (evt) => {
					return evt.route === this.$route.name;
				});
				this.eventID = to.params.id ? to.params.id : typedEvents[0].id;
				this.eventItems = typedEvents;
			}
		},
	},
	methods: {
		setID(id) {
			this.eventID = id;
		},
	},
	created() {
		const typedEvents = _.filter(Events, (evt) => {
			return evt.route === this.$route.name;
		});
		//console.log(typedEvents, this.$route.params.id);
		this.eventID = this.$route.params.id
			? this.$route.params.id
			: typedEvents[0].id;
		this.eventItems = typedEvents;
	},
};
</script>
<style scoped>
.box {
	filter: brightness(100%);
}
.box:hover {
	filter: brightness(50%);
}
a {
	text-decoration: none;
}
.overlayText {
	text-align: center;
	color: white;
}
.active {
	background-color: lightgrey;
}
</style>
